import React from "react";
import {IFormData, ILineItemField} from "../../EditInvoice";
import LineItemRow from "./LineItemRow";
import { SiteProps } from "../../../../../interfaces";
import { CampProps } from "~/interfaces";
import classNames from "~/utils/classNames";


interface LineItemsTableProps {
  resource: IFormData
  items: ILineItemField[]
  isForPrint: boolean
  isPreview: boolean
  site: SiteProps
  isRecurring: boolean
  camp: CampProps
}

const LineItemsTable = ({ resource, items, isForPrint, isPreview, site, isRecurring, camp }: LineItemsTableProps) => {
  return (
    <div
      className={classNames(isPreview ? "hide-scrollbar-for-preview" : "hide-scrollbar", "hidden mdlg:block")}
      style={{ maxWidth: "95vw", display: isForPrint && "block" }}
    >
      <div style={{ minWidth: !isForPrint ? 912 : "auto" }}>
        <div
          className={classNames(
            resource.is_displaying_occurrences ? "grid-cols-10" : isPreview ? "grid-cols-8" : "grid-cols-9",
            "grid mdlg:grid-cols-12 gap-2 font-bold mb-2.5 text-baselg pb-1.5 border-b border-gray-900",
          )}
        >
          <div className={resource.is_displaying_occurrences ? "col-span-2 mdlg:col-span-4" : "col-span-2 lg:col-span-5"}>
            Item
          </div>
          <div className="col-span-2">Price</div>
          {resource.is_displaying_occurrences && <div className="col-span-1">Nights</div>}
          <div className="col-span-2">Quantity</div>
          <div className="col-span-2">Amount</div>
        </div>
        {items?.filter((item) => !item.is_hidden).length === 0 && (
          <div className="w-full py-4 text-center text-gray-400">
            No Line items. Apply electric fees or add a new item.
          </div>
        )}
        {items?.map((item, index) => (
          <LineItemRow
            camp={camp}
            key={index}
            index={index}
            item={{ ...item, is_hidden: isForPrint ? item.unit_amount == 0 : item.is_hidden }}
            isPreview={isPreview}
            site={site}
            isRecurring={isRecurring}
            isForPrint={isForPrint}
          />
        ))}
      </div>
    </div>
  )
}

export default LineItemsTable;